<template>
  <basic-container id="carChargeRecord20220301">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :search.sync="searchForm"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from './carChargeRecord';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';

export default {
  data() {
    return {
      searchForm: {},
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      tempSpaceId: '',
      spaceList: [],
      option: {
        height: 'auto',
        calcHeight: 90,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        labelWidth: 100,
        editBtn: false,
        selection: true,
        searchShow: true,
        delBtn: false,
        searchMenuSpan: 6,
        span: 6,
        columnBtn: false,
        refreshBtn: true,
        menu: false,
        multiple: false,
        searchMultiple: false,
        filterMultiple: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '车场名称',
            type: 'tree',
            prop: 'parkingLotId',
            hide: true,
            editDisabled: false,
            clearable: false,
            span: 8,
            search: true,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },
          {
            label: '车场名称',
            prop: 'parkingLotName',
            hide: false,
            display: false,
            addDisplay: false,
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            search: true,
            editDisabled: true,
            filterable: false,
            span: 8,
            rules: [
              {
                required: true,
                message: '请选择车牌号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
              },
            ],
          },
          {
            label: '车主姓名',
            span: 8,
            prop: 'driverName',
            width: 70,
            search: true,
            maxlength: 10,
            disabled: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入客户姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '手机号码',
            prop: 'mobile',
            width: 100,
            span: 8,
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车辆类别',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_category_v2',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'carCategory',
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
              },
            ],
          },
          {
            label: '充值金额',
            prop: 'tradeFee',
            hide: false,
            display: false,
            addDisplay: false,
          },
          {
            label: '交易时间',
            prop: 'payOrRefundTime',
            hide: false,
            display: false,
            addDisplay: false,
          },
        ],
      },
      data: [],
    };
  },

  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carChargeRecord_add, false),
        viewBtn: this.vaildData(this.permission.carChargeRecord_add_view, false),
        delBtn: this.vaildData(this.permission.carChargeRecord_add_delete, false),
        editBtn: this.vaildData(this.permission.carChargeRecord_add_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[1].dicData = data.data;
        this.option.column[1].searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.searchForm.parkingLotId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
      }
      this.onLoad();
    });
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.searchForm = {};
      this.query = {};
      this.searchForm.parkingLotId = this.tempSpaceId;
      this.query.parkingLotId = this.tempSpaceId;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempSpaceId;
      }
      if (this.query.parkingLotId == '') {
        return;
      }
      this.tempSpaceId = this.query.parkingLotId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss">
#carChargeRecord20220301 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
